export const ROOT = "/";
export const LOGIN = "/login";

export const TABLE_LIST = "/table-list";
export const UPDATE_TABLE_STRUCTURE = "/table-details/:updateTableName";
export const VIEW_TABLE_DATA = "/table-data/:viewTableName";



export const REQUEST_LIST = "/request-list";
export const UPDATE_REQUEST_STRUCTURE = "/request-details/:updateRequestName";
export const DYNAMIC_REQUEST_VIEW = "/dynamic-request-view/:requestId";
export const VIEW_REQUEST_DATA = "/request-data/:viewRequestName";
// export const VIEW_SINGLE_PARAMETER_VALIDATION_LIST = "/:{request-name}-{parameter-name}";
export const VIEW_SINGLE_PARAMETER_VALIDATION_LIST = "/:requestName/:parameterName";
export const COMMAND_LIST = "/command-list";

//Clients
export const CLIENT_LIST = "/client-list";
export const CLIENT_ADD_UPDATE = "/client-add-update/:clientId";

export const VIEW_SELECTED_CLIENT_DATA = "/client/{clientId}";

//Generic Form URL
export const GENRIC_URL = "/gen/:path/:id";

export const USER_GROUP = "/user-group";
export const USER_MASTER = "/users";
export const USER_PROFILE = "/users/:id";

export const ROLE_MASTER = "/roles";
export const PERMISSION_MASTER = "/permissions";
export const MODULE_MASTER = "/modules";

export const NEW_USER = "/new-user";
export const GROUP_LIST = "/group-list";
export const NEW_GROUP = "/new-group";
export const GROUP_DETAILS = "/group-details";
export const DASHBOARD = "/dashboard";
export const DASHBOARD_DETAIL = "/dashboard/:id";
export const DASHBOARD_ITEM_DETAIL = "/dashboard-item/:id";

// CDP
export const CDP_DASHBOARD = "/cdp/dashboard";
export const CDP_PROFILES = "/cdp/profiles";
export const CDP_EVENTS = "/cdp/events";
export const CDP_SEGMENTS = "/cdp/segments";
export const CDP_CAMPAIGNS = "/cdp/campaigns";
export const CDP_RULES = "/cdp/rules";
export const CDP_CONTEXT = "/cdp/context";
export const CDP_PRIVACY = "/cdp/privacy";
export const CDP_PROFILE_DETAIL = "/cdp/profile/:id";
export const CDP_SCORING = "/cdp/scoring";
export const CDP_GOALS = "/cdp/goals";
export const CDP_SETTINGS = "/cdp/settings";
export const CDP_REPORTS = "/cdp/reports";
export const CDP_MONITOR = "/cdp/monitor";

//Workflow
export const WORKFLOW_LIST = "/workflows";
export const WORKFLOW_CREATE = "/workflows/:workflowId";
